module.exports = __webpack_public_path__ + "static/media/WorkOrders.b216ede3.png";